import React, { useState, useMemo, useEffect, useContext } from "react";
import { Button } from "antd";
import axios from "@common/axios";
import DynamicContent from "../nav/DynamicContent";
import {UserContext} from "@context/UserContext";
import TableAntD from "@common/TableAntD";

const QuestionFeedBackTable = (props) => {
    const {user} = useContext(UserContext);
    const { feedbackViewed } = props;
    const [viewingCluster, setViewingCluster] = useState(false);
    const [questionClusterId, setQuestionClusterId] = useState();
    const [questionClusterResultId, setQuestionClusterResultId] = useState();

    useEffect(() => {
        setViewingCluster(false);
    }, [feedbackViewed]);

    const dataAdapterQuestionClusterResults = (contentArray = []) => {
        return contentArray.map((item, index) => {
            return {
                className: item.className || '',
                teacherName: item.teacherName,
                conceptName: item.conceptName,
                questionClusterId: item.questionClusterId,
                questionClusterResultId: item.questionClusterResultId,
                mark:
                    item.maxMark && item.maxMark > 0
                        ? `${item.totalMark} / ${item.maxMark}`
                        : "N/A",
                date: user.dateTimeFormat.format(item.answerDate)
            };
        });
    };


    const fetchData = (pagingParams, handleTableData, handlePagingData, abortController) => {
        const queryParams = {
            pageNumber: pagingParams.pageNumber,
            pageSize: pagingParams.pageSize,
            feedbackViewed,
        };

        axios.get("/web/ui/question/marking/studentMarkedQuestions", {
                params: queryParams,
                signal: abortController.signal
            })
            .then((response) => {
                if (response && response.data) {
                    const adaptedData = dataAdapterQuestionClusterResults(
                        response.data.currPageContents
                    );
                    handleTableData(adaptedData);
                    handlePagingData({
                        pageSize: pagingParams.pageSize,
                        totalResults: response.data.totalResults ?? 0,
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                handleTableData([]);
            });
    };

    const columns = [
        {
            title: "Class",
            dataIndex: "className",
            key: "className",
        },
        {
            title: "Teacher",
            dataIndex: "teacherName",
            key: "teacherName",
        },
        {
            title: "Lesson",
            dataIndex: "conceptName",
            key: "conceptName",
            render: (text, record) => (
                <a className={'ch-link'}
                   tabIndex={0}
                    onClick={() =>
                        handleClusterClick(record.questionClusterId, record.questionClusterResultId)
                    }
                >
                    {text}
                </a>
            ),
        },
        {
            title: "Mark",
            dataIndex: "mark",
            key: "mark",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
    ];

    const handleClusterClick = (qClusterId, qClusterResultId) => {
        setQuestionClusterId(qClusterId);
        setQuestionClusterResultId(qClusterResultId);
        setViewingCluster(true);
    };

    const handleBackClick = () => {
        setViewingCluster(false);
    };

    // const QuestionClusterResultsTable = useMemo(() => {
    //
    // }, [feedbackViewed]);

    const loadQuestionClusterResultCallback = () => {
        const $questionClusterResult = $('.js-clusterResultsBlk');
        $questionClusterResult.addClass(
            "js-tabs js-question-cluster simple-tabs inline-questions-blk"
        );
        setupQuestionCLusterNavigation();
        initQuestionClusterResult($questionClusterResult, questionClusterId);
        loadQuestionClusterResultPieCharts($questionClusterResult);

        // Cluster scrolling
        if (!window.questionClusters.scrollInit) {
            initQuestionClusterOnChange();
            initQuestionClusterScrolling();
        }

        $('.genBtn-blk', $questionClusterResult).hide();
        $('.js-pageBtnCont').hide();
        $('.js-markedWordBack').show();
        $('.exampleLink, .cont-link-example, .skillsheet').hide();
    };

    return (
        <div>
            {viewingCluster && (
                <div className="flexJustifyEnd">
                    <Button onClick={handleBackClick} type={'primary'}>
                        Back
                    </Button>
                </div>
            )}

            <div className="ch-tab-body" style={{ marginTop: viewingCluster ? 20 : 0 }}>
                {viewingCluster ? (
                    <DynamicContent
                        className="js-clusterResultsBlk"
                        url={"/lessonSection/loadQuestionsClusterResultsNav.action"}
                        params={{
                            questionClusterId,
                            questionClusterResultId,
                            singleQuestionView: true,
                        }}
                        callback={loadQuestionClusterResultCallback}
                    />
                ) : (
                    <TableAntD
                        pagingDependencies={[feedbackViewed]}
                        pagingData={{fetchFunction:fetchData, params:{
                                pageSize: 10,
                                currentPage: 1,
                            }}}
                        rowKey="questionClusterResultId"
                        columnData={columns}
                        noDataMessage={'No teacher feedback found'}
                        dynamicWidth={true}
                    />
                )}
            </div>
        </div>
    );
};

export default QuestionFeedBackTable;
